import ProfessorDataStore from '../../datastores/ProfessorDataStore';

export default class ProfessorDataStoreGraphQL implements ProfessorDataStore {
  async getProfessors() {
    return [
      {
        code: 'C19980',
        courseId: '013776',
        email: 'C19980@utp.edu.pe',
        firstName: 'JOSE LUIS',
        id: '09000007191',
        lastName: 'BRIONES',
        phone: '982669656',
        photo: 'https://webprojects2.utp.edu.pe/fotos/utp/docentes/C19980.jpg',
        type: 'PI'
      }
    ];
  }
}
